<!--隐私条款-->
<template>
  <div :class="[isPc ? 'policy-box-pc' : 'policy-box']">
    <van-dialog
      v-model="policyShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'3.36rem'"
    >
      <template #default>
        <div class="policy-content">
          <div class="title">{{content.policy}}</div>
          <div
            class="policy-p"
            v-html="policyDesc"
          >
          </div>
          <div class="policy-check" v-if="needCheck">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="policyBtn"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="policyBtn"
          >{{content.sure}}</van-button>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { postProtocol, getProtocol } from '@/models/common'
export default {
  data(){
    return {
      policyShow: false, // 隐私条款弹窗
      policyCheck: false, // 勾选隐私条款
      policyDesc: '', // 协议内容
      needCheck: true, // 是否需要勾选协议
    }
  },
  props: {
    room: {
      type: [String,Number],
      default: ''
    }
  },
  watch: {
    'room': function(val){
      if(val){
        this.initProtocol('watch')
      }
    }
  },
  // created() {
  //   this.initProtocol()
  // },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  mounted() {
    this.initProtocol()
  },
  methods: {
    // 弹出隐私条款
    showDialog(){
      this.needCheck = true
      this.policyShow = true
    },
    // 弹出隐私条款不需要勾选
    showDialogWithoutCheck(){
      this.needCheck = false
      this.policyShow = true
    },
    // 获取隐私条款
    async initProtocol() {
      const _this = this
      const { data } = await postProtocol({ //获取直播协议
        live_meet_id: Number(_this.room)
      })
      if (data.code == 0) {
        // 有直播协议则显示直播协议，否则，如果是刚进来时直接跳过，如果是点发言、抽奖触发的登录则显示注册协议
        if (data.data.protocol_content) { //有协议的情况
          _this.policyDesc = data.data.protocol_content;
          localStorage.setItem('live_h5_protocol_content',_this.policyDesc); //将获取到的隐私条款保存在本地
        } else { //没有协议
          localStorage.removeItem('live_h5_protocol_content'); //删除本地的隐私条款
          // 注册协议
          let domain_code = location.host.split('.')[1]
          console.log('location.host',domain_code)
          const res = await getProtocol({ //获取注册协议
            type: this.lanuage=='Chinese'?'REG':'REG_EN',
            domain_code
          })
          if(res.data.code == 0 && res.data.data.content){
            _this.policyDesc = res.data.data.content
          }
        }
      }
    },
    // 隐私条款按钮
    policyBtn() {
      // 需要勾选协议则验证是否勾选协议，否则直接关闭协议弹窗即可
      if(this.needCheck){
        if (!this.policyCheck) {
          this.$toast(this.content.needCheckPolicy)
        } else {
          let rooms = localStorage.getItem('rooms') ? JSON.parse(localStorage.getItem('rooms')) : []
          rooms.push(Number(this.room))
          localStorage.setItem('rooms', JSON.stringify(rooms))
          this.policyShow = false
          this.$emit('agreePolicy')
        }
      }else {
        this.policyShow = false
      }
    },
    // 检查是否有设置隐私条款
    async getHaveProtocol(room,type) {
      alert('来源------'+type)
      const { data } = await postProtocol({
        live_meet_id: Number(room)
      })
      if (data.code == 0) {
        if (data.data.protocol_content) {
          return true
        } else {
          return false
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.van-dialog {
  border-radius: 6px;
}
.policy-box-pc{
  .policy-content {
    padding: 0 0.55rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.2rem;
    }
    .policy-p {
      max-height: 3.67rem;
      min-height: 1rem;
      overflow-y: auto;
      font-size: 0.19rem;
      color: #666666;
      line-height: 0.25rem;
      /deep/pre {
        white-space: pre-wrap;
        margin: 0;
      }
    }
    .policy-check {
      margin-top: 0.15rem;
    }
    /deep/.van-icon{
      line-height: 1;
    }
    /deep/.van-checkbox__label {
      font-size: 0.16rem;
    }
    .policyBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.15rem auto 0.3rem;
      display: block;
    }
  }
}
.policy-box{
  .policy-content {
    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
    }
    .policy-p {
      max-height: 3.67rem;
      overflow-y: auto;
      font-size: 0.15rem;
      color: #666666;
      line-height: 0.25rem;
      /deep/pre {
        white-space: pre-wrap;
        margin: 0;
      }
    }
    .policy-check {
      margin-top: 0.05rem;
    }
    /deep/.van-checkbox__label {
      font-size: 0.16rem;
    }
    .policyBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.15rem auto 0.25rem;
      display: block;
    }
  }
}
</style>
